import React from "react";
import ContactSection from "../components/Contact_Section";

function Contact() {
  return (
    <>
      <ContactSection />
    </>
  );
}

export default Contact;
